module.exports = __webpack_public_path__ + "img/logo.60e20609.png";